import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons, componentsPlugin, IconsPlugin} from 'bootstrap-vue'

import './registerServiceWorker'
import router from './router'
import store from './store'

// import bootstrap vue
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
// register bootstrap vue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)

// register vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.config.productionTip = false

// axios
import axios from "axios";
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/axios'
axios.defaults.baseURL = 'https://api.zehneboursi.ir/api/';

// import main requirements
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/MainRequirements'

// register miw-components
import '@moeinmdn/miw-components/src/plugin/indexComponents'
import App from './App.vue'

// authenticate user
store.dispatch('Authentication/attemptLogin').then(async () => {

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')

})
